export default __webpack_public_path__ + "static/young-toddler12-dbf7d846d0677ec784b8b6872cb2f0a2.jpg";